import { render, staticRenderFns } from "./planList.vue?vue&type=template&id=c54dae92&scoped=true"
import script from "./planList.vue?vue&type=script&lang=js"
export * from "./planList.vue?vue&type=script&lang=js"
import style0 from "../asset/css/list.scss?vue&type=style&index=0&id=c54dae92&prod&lang=scss&scoped=true&external"
import style1 from "./planList.vue?vue&type=style&index=1&id=c54dae92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54dae92",
  null
  
)

export default component.exports